// @flow
import moment from 'moment';

export const getCashbackExpirationInfo = (
  expiresAt: ?string,
  isExpired?: ?boolean,
) => {
  if (isExpired || !expiresAt) {
    return {
      daysLeft: null,
      showExpiration: false,
      expirationTextColor: '#ce3c25',
      expirationBgColor: '#faeaea',
      expirationText: '',
    };
  }

  const expirationDate = moment(expiresAt).startOf('day');
  const today = moment().startOf('day');

  const daysLeft = expirationDate.diff(today, 'days');

  if (daysLeft < 0 || daysLeft > 14) {
    return {
      daysLeft: 0,
      showExpiration: false,
      expirationTextColor: '#ce3c25',
      expirationBgColor: '#faeaea',
      expirationText: '',
    };
  }

  let expirationTextColor = '#ce3c25';
  let expirationBgColor = '#faeaea';

  if (daysLeft > 3) {
    expirationTextColor = '#eb5b1e';
    expirationBgColor = 'rgba(235, 91, 30, 0.1)';
  }

  const expirationText =
    daysLeft === 0
      ? 'hoje'
      : `em ${daysLeft} ${daysLeft === 1 ? 'dia' : 'dias'}`;

  return {
    daysLeft,
    showExpiration: true,
    expirationTextColor,
    expirationBgColor,
    expirationText,
  };
};